var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"profile-loader text-center py-5"},[_c('div',{staticClass:"loader-spinner mb-3"},[_c('base-table-spinner')],1),_c('div',{staticClass:"loader-text"},[_c('h4',{staticClass:"mb-2"},[_vm._v(_vm._s(_vm.loadingMessage))]),_c('p',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.subMessage))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }